/* eslint-disable no-negated-condition */
/* eslint-disable prefer-template */
/* eslint-disable no-unsafe-optional-chaining */
import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_USER_ADDON_LISTING } from 'pages/Vendor/VendorGraphQL';
import Loader from 'components/common/Loader';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { modifiedUnderScore } from 'utils/constants';

const VendorAddOnListing = ({ traderId }) => {
  const { data, loading, error } = useQuery(GET_USER_ADDON_LISTING, {
    variables: { traderId },
    fetchPolicy: 'network-only',
  });

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <ErrorBoundary>
      <span className="f-12 text-active fw-medium mb-1 d-block text-uppercase">
        ADD-ONS
      </span>
      <span className="f-12 text-dark-525 fw-medium d-block">
        {data?.findAddonByTraderId?.length
          ? data?.findAddonByTraderId?.map((item, index) => (
              <span key={item?.id}>
                {modifiedUnderScore(item?.addOnTypes)}
                {index !== data.findAddonByTraderId.length - 1 ? ', ' : ''}
              </span>
            ))
          : 'Not Available'}
      </span>
    </ErrorBoundary>
  );
};

export default VendorAddOnListing;
